export function getChalkboardPlayList(playList, timeSelected, playValuesIndex) {
  // If time selected length is equal to 6, means that all time sections are selected,
  // thus avoid loop
  if (timeSelected.length === 6) return playList;
  return playList.filter(play => timeSelected.includes(play[playValuesIndex.section]));
}

export function getChalkboardGames(teams, games) {
  return games.map(g => {
    let home_team = teams.find(t => t.team_id === g.home_team);
    let visiting_team = teams.find(t => t.team_id === g.visiting_team);
    if (home_team && visiting_team) {
      return {
        gameId: g.game_id,
        title: `${home_team.team_name} VS ${visiting_team.team_name}`,
        homeTeamId: g.home_team,
        homeTeamName: home_team.team_name,
        homeTeamLogo: home_team.logo,
        visitingTeamId: g.visiting_team,
        visitingTeamName: visiting_team.team_name,
        visitingTeamLogo: visiting_team.logo,
      };
    }
  });
}
